import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID, SFApptTimeSlots } from 'utils/types';
import SlotsSection from './SlotsSection';
import SlotsListOptions from './SlotsListOptions';

export default class SlotsList extends React.Component {

  groupByRecurrence(slots) {
    const [slotsByDay, knownRecurrences] = [[], []];
    slots.map(slot => {
      const recurrenceLabel = slot.slotTimeRangeWithRecurrenceStart;
      const index = knownRecurrences.indexOf(recurrenceLabel);
      if ( index === -1 ) {
        knownRecurrences.push(recurrenceLabel);
        slotsByDay.push([slot]);
      } else slotsByDay[index].push(slot);
    });
    return slotsByDay;
  }

  availableSlots(slots, index) {
    return this.groupByRecurrence(slots)[index].length;
  }

  render() {
    return (
      <div>
        {this.groupByRecurrence(this.props.visibleSlots).map((visibleSlots, i) => (
          <SlotsSection
            key={i}
            time={visibleSlots[0].slotTimeRangeWithRecurrenceStart}
            availableSlots={this.availableSlots(this.props.allSlots, i)}
            recurring={this.props.recurring}>
            <SlotsListOptions
              slots={visibleSlots}
              slotStartDate={this.props.slotStartDate}
              slotOwnerId={this.props.slotOwnerId}
              onSlotSelected={this.props.onSlotSelected}
              isService={this.props.isService}
              currentDuration={this.props.currentDuration}
              locationName={this.props.locationName}
            />
          </SlotsSection>
        ))}
      </div>
    );
  }
}

SlotsList.propTypes = {
  recurring: PropTypes.bool,
  allSlots: SFApptTimeSlots.isRequired,
  visibleSlots: SFApptTimeSlots.isRequired,
  slotStartDate: PropTypes.object,
  slotOwnerId: SFEntityID,
  onSlotSelected: PropTypes.func.isRequired,
  isService: PropTypes.bool.isRequired,
  currentDuration: PropTypes.number,
  locationName: PropTypes.string
};
